<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
import { mapGetters } from 'vuex'

const animationDuration = 3000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    travelProperties: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 10,
    },
  },
  watch: {
    travelProperties: {
      deep: true,
      handler(val) {
        if (val) {
          let names = this.travelProperties.map(function (value, index, array) {
            return value.name
          })
          this.setOptions(val, names)
        }
      },
    },
  },
  created() {
    let names = this.travelProperties.map(function (value, index, array) {
      return value.name
    })
    this.names = names
  },
  computed: {
    ...mapGetters(['device']),
  },
  data() {
    return {
      chart: null,
      names: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })
      this.setOptions(this.travelProperties, this.names)
    },
    setOptions(travelProperties, names) {
      var option
      option = {
        title: {
          text: '性質分佈',
        },
        legend: {
          data: names,
          left: 'center',
          bottom: '10',
        },
        grid: {
          left: 10,
          right: 15,
          bottom: 25,
          top: 40,
          containLabel: true,
        },
        // tooltip: {
        //   confine: true,

        // },
        radar: {
          radius: this.device == 'mobile' ? '60%' : '70%',
          center: ['50%', '45%'],
          indicator: [
            { name: '散客團', max: this.max },
            { name: '親友團', max: this.max },
            { name: '員工旅遊', max: this.max },
            { name: '獎勵旅遊', max: this.max },
            { name: '學生畢旅', max: this.max },
            { name: '其他團體', max: this.max },
          ],
        },
        series: [
          {
            type: 'radar',
            data: travelProperties,
            animationDuration: animationDuration,
            color: ['#2F5CFF'],
          },
        ],
      }
      var leg = ['散客團', '親友團', '員工旅遊', '獎勵旅遊', '學生畢旅', '其他團體']
      option.tooltip = {
        confine: true,
        trigger: 'item',
        formatter: function (params) {
          let relVal = params.name
          for (let i = 0; i < params.data.value.length; i++) {
            relVal += '<br/>' + leg[i] + ' : ' + params.data.value[i] + ' ' + '團'
          }
          return relVal
        },
      }
      if (option && typeof option === 'object') {
        this.chart.setOption(option)
      }

      window.addEventListener('resize', this.chart.resize)
    },
    initChart_beforeVersion() {
      let vm = this
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        radar: {
          radius: '66%',
          center: ['50%', '42%'],
          splitNumber: 8,
          splitArea: {
            areaStyle: {
              color: 'rgba(127,95,132,.3)',
              opacity: 1,
              shadowBlur: 45,
              shadowColor: 'rgba(0,0,0,.5)',
              shadowOffsetX: 0,
              shadowOffsetY: 15,
            },
          },
          indicator: [
            { name: '散客團', max: this.max },
            { name: '親友團', max: this.max },
            { name: '員工旅遊', max: this.max },
            { name: '獎勵旅遊', max: this.max },
            { name: '學生畢旅', max: this.max },
            { name: '其他團體', max: this.max },
          ],
        },
        legend: {
          left: 'center',
          bottom: '10',
          //data: ["2020", "2021", "2022"],
          data: vm.names,
        },
        series: [
          {
            type: 'radar',
            symbolSize: 0,
            areaStyle: {
              normal: {
                shadowBlur: 13,
                shadowColor: 'rgba(0,0,0,.2)',
                shadowOffsetX: 0,
                shadowOffsetY: 10,
                opacity: 1,
              },
            },
            data: vm.travelProperties,
            // data: [
            //   {
            //     value: [5000, 7000, 12000, 11000, 15000, 14000],
            //     name: "2020",
            //   },
            //   {
            //     value: [4000, 9000, 15000, 15000, 13000, 11000],
            //     name: "2021",
            //   },
            //   {
            //     value: [0, 0, 0, 0, 0, 0],
            //     name: "2022",
            //   },
            // ],
            animationDuration: animationDuration,
          },
        ],
      })
    },
  },
}
</script>
